import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../../hooks/useApi';
import { IPlanRes } from '../rtmTemplate/index.type';

const useAllPlan = () => {
  const [planData, setPlanData] = React.useState<IPlanRes>();
  
  const { loading: planDataLoading, makeApiCall } = useApi({
    url: `/RTM/getPlanWithOptions`,
    method: 'GET',
  });

  const getPlanData = async () => {
    const { response, error } = await makeApiCall<undefined,IPlanRes>();
    console.log(response?.data)
    if (response?.status === 'success') {
    return response.data
    }

    if (response?.status === 'fail') {
        return
    }

    if (error) toast.error('Something went wrong while fetching clinic data. Please try again later');
  };

  return {
    planData,
    getPlanData,
    planDataLoading,
  };
};

export default useAllPlan;
